export const list = {
  title: {
    name: '项目名称',
    key: 'title',
    check: true
  },
  creator: {
    name: '创建者',
    key: 'creator'
  },
  addtime: {
    name: '创建时间',
    key: 'addtime'
  },
  delete_time: {
    name: '删除日期',
    key: 'delete_time'
  },
  isJoin: {
    name: '加入状态',
    key: 'isJoin'
  }
}
